import { render, staticRenderFns } from "./setMuti.vue?vue&type=template&id=8bdefc82&scoped=true"
import script from "./setMuti.vue?vue&type=script&lang=js"
export * from "./setMuti.vue?vue&type=script&lang=js"
import style0 from "./setMuti.vue?vue&type=style&index=0&id=8bdefc82&prod&lang=stylus&scoped=true"
import style1 from "./setMuti.vue?vue&type=style&index=1&id=8bdefc82&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdefc82",
  null
  
)

export default component.exports